<app-module-error *ngIf="somethingWentWrong && !isDataLoading"></app-module-error>
<div #gameContainer class="cards-container d-flex flex-column" [hidden]="somethingWentWrong">
    <div class="search-container" [hidden]="isSearchHidden">
        <sol-text-input class="w-100"
            [placeholderText]="getLocalizationString('Search','Search for Search')" type="search"
            [(ngModel)]="searchTerm" (ngModelChange)="applySearchFilter()"
            (ngModelChangeDebounced)="searchTerm"
            [leadingIcon]="icon">
        </sol-text-input>
    </div>
    <ng-template #icon>
        <svg class="icon-16">
            <use href="../App_Themes/CXone/icons/gamification/cxone-sol-search.svg#cxone-sol-search">
            </use>
        </svg>
    </ng-template>

    <overlay-scrollbars [options]="currentView !== 0 ? hiddenScrollOptions : scrollOptions" 
    [style.height]="currentView !== 0 ? '0%' : ''" class="class-scroll flex-grow-1 pb-0 mt-0">
        <div [hidden]="!noData" class="error-container">
            <svg class="error-icon">
                <use href="../App_Themes/CXone/icons/empty.svg#empty"></use>
            </svg>
            <p class="cxone-error-text" cvLocalizedText langSection="Games_Module" langKey="CXone_Data_Error">
                No data available
            </p>
        </div>

        <div *ngIf="!noData" class="d-flex flex-column" container="body">
            <div *ngIf="filteredSupervisors.length > 0" #agentsDiv>
                <div *ngFor="let supervisor of filteredSupervisors" style="min-height: 100%;" #trackerCardsDiv [attr.id]="supervisor?.LoginID">
                    <cxone-agent-card [supervisor]="supervisor" [supervisorData]="findObjectByAgentID(supervisor?.LoginID)" (seeMoreStatus)="onSeeMoreStatusChange($event)" (agentUpdated)="syncAgent($event)" (agentSelected)="handleSupervisorSelected($event)"></cxone-agent-card>
                </div>
            </div>
        </div>
        <div [hidden]="!(filteredSupervisors.length === 0 && searchTerm !== '') || isDataLoading" class="error-container">
            <svg class="error-icon">
                <use href="../App_Themes/CXone/icons/no-search-results-new.svg#no-search-results-new"></use>
            </svg>
            <p>{{ getLocalizationString("No_Results_Found", "No results found") }}</p>
        </div>
    </overlay-scrollbars>
</div>

